export function GetProductionProgress(completed: number,required: number) {
	const percentage = completed/required * 100;
	return Number(percentage.toFixed(0));
}